/*
 * @Author: Lim 
 * @Date: 2020-09-09 19:58:44 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-09-11 10:58:23
 */

// props初始化
export const initConfig = ( defaultData, propsData ) => {
    let config = defaultData;
    if( Boolean(propsData) ) config = Object.assign( defaultData,propsData )
    return config;
}
// 单位过滤
export const unitFilter = ( defaultValue ) => {
    let value = null;
    if( defaultValue === '' || defaultValue === null ){
        value = '';
    }else{
        let ValueToString = JSON.stringify( defaultValue );
        value = ( ValueToString.indexOf("%") > -1 || ValueToString.indexOf("vh") > -1 || ValueToString.indexOf("vw") > -1 || ValueToString.indexOf("rem") > -1 || ValueToString.indexOf("em") > -1 ) ? JSON.parse( ValueToString ) : parseInt( defaultValue );
    }
    return value;
}